import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import OrderAssignDialog from "../../../components/customHelpers/OrderAssignDialog";
import Controls from "../../../components/controls/Controls";
import Norecords from "../../../components/customHelpers/Norecords";
import Loading from "../../../components/customHelpers/Loading";
import Layout from "../../../components/layout/Layout";
import { TableBody, TableRow, TableCell, Typography } from "@material-ui/core";
import { Grid, Toolbar, InputAdornment } from "@material-ui/core";
import { useEffect, useState } from "react";
import { MdOutlineDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../../components/customHelpers/useTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import { FiEdit, FiEye } from "react-icons/fi";
import { MdAssignmentInd } from "react-icons/md";
import Admin from "../../../components/auth/Admin";
import Order from "../../../actions/order";
import UpdateOrder from "../../../components/forms/addOrders";
import Popup from "../../../components/customHelpers/Popup";
import produce from "immer";
import { useHistory } from "react-router-dom";
import Assigntff from "./assignToUser";
import { isAuth } from "../../../actions/auth";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Paper,
  Radio,
} from "@mui/material";

const headCells = [
  { id: "id", label: "Id" },
  { id: "customer", label: "Customer" },
  { id: "assignTo", label: "Assigned To" },
  { id: "quantity", label: "Item Count" },
  { id: "totalPrice", label: "Total Price" },
  { id: "paid", label: "Paid" },
  { id: "unpaid", label: "Balance" },
  { id: "createdAt", label: "Date" },
  { id: "status", label: "Status" },
  { id: "actions", label: "Actions", disableSorting: true },
];

const ShipmentOrder = () => {
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewShipmentOrders, viewUserShipmentOrders, deleteMainOrder } =
    Order();
  const [recordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopupAssign, setOpenPopupAssign] = useState(false);

  const [edit] = useState(false);
  const [id, setId] = useState(null);
  const [orders, setOrders] = useState([]);
  const [temp, setTemp] = useState([]);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  useEffect(() => {
    getAllShipmentOrders();
  }, [reload]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [orderConfirmDialog, setOrderConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [additionalConfirmDialog, setAdditionalConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
    onConfirm: () => {},
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const getAllShipmentOrders = () => {
    setValues({ ...values, loading: true });
    viewShipmentOrders().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setValues({
          ...values,
          loading: false,
        });
        const modifiedOrders = data.orders.map((order) => ({
          ...order,
          customer: order?.customer?.fullName,
        }));
        setOrders(modifiedOrders);
        setTemp(modifiedOrders);
        setCheckedItems("all"); // Default to "All" selected
      }
    });
  };
  const getUserShipmentOrders = () => {
    setValues({ ...values, loading: true });
    viewUserShipmentOrders().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setValues({
          ...values,
          loading: false,
        });
        setOrders(data.orders);
      }
    });
  };

  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteMainOrder(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
        setOrders(
          produce(orders, (draft) => {
            const index = orders.findIndex((item) => item.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(orders, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["status", "customer", "id"];

        if (target.value == "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  const calculateTotalPrice = (data) => {
    let totalPrice = 0;
    if (data.length > 0) {
      data.forEach((order) => {
        totalPrice += parseFloat(order.totalPrice);
      });
      return totalPrice.toFixed(2); // Return the total price rounded to 2 decimal places
    }
  };
  const [checkedItems, setCheckedItems] = useState({
    myCreatedOrder: false,
    myAssignedOrder: false,
    all: false,
  });

  const handleRadioChange = (event) => {
    const value = event.target.value;
    if (value === "myAssignedOrder") {
      const filteredOrders = temp.filter(
        (order) => order.assignTo === isAuth()?.id
      );
      setOrders(filteredOrders);
    } else if (value === "myCreatedOrder") {
      const filteredOrders = temp.filter(
        (order) => order.uploded_by === isAuth()?.id
      );
      setOrders(filteredOrders);
    } else { // "all"
      setOrders(temp);
    }
    setCheckedItems(value);
  };

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Shipment Orders
          </Typography>
          <Toolbar>
            <Controls.Input
              label="Search Shipment"
              className="searchInput"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />
          </Toolbar>
          <Box display="flex" justifyContent="flex-end" gap={1} m={1}>
            <FormGroup style={{ display: 'flex', flexDirection: 'row' }}>
              <FormControlLabel
                control={
                  <Radio
                    checked={checkedItems === "myCreatedOrder"}
                    onChange={handleRadioChange}
                    value="myCreatedOrder"
                  />
                }
                label="My Created Order"
              />
              <FormControlLabel
                control={
                  <Radio
                    checked={checkedItems === "myAssignedOrder"}
                    onChange={handleRadioChange}
                    value="myAssignedOrder"
                  />
                }
                label="My Assigned Order"
              />
              <FormControlLabel
                control={
                  <Radio
                    checked={checkedItems === "all"}
                    onChange={handleRadioChange}
                    value="all"
                  />
                }
                label="All"
              />
            </FormGroup>
          </Box>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{`${item.id.slice(0, 7)}---`}</TableCell>
                            <TableCell>{item.customer}</TableCell>
                            <TableCell>{item.staff?.fullName}</TableCell>
                            <TableCell>{item?.orderProducts?.length}</TableCell>
                            <TableCell>
                              {item?.orderProducts?.length > 0
                                ? calculateTotalPrice(item.orderProducts)
                                : 0}
                            </TableCell>
                            <TableCell>{item.paid}</TableCell>
                            <TableCell>
                              {calculateTotalPrice(item.orderProducts) -
                                item.paid}
                            </TableCell>
                            <TableCell>
                              {new Date(item.createdAt).toLocaleString()}
                            </TableCell>
                            <TableCell>{item.status}</TableCell>
                            <TableCell>
                            <div
                                style={{
                                  display: "flex",
                                  gap: "5px",
                                  flexWrap: "nowrap",
                                }}
                              >
                              <Controls.ActionButton
                                color="primary"
                                title="View Detail"
                                onClick={() => {
                                  history.push(`/shipment/${item.id}`);
                                }}
                              >
                                <FiEye fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="Assign"
                                onClick={() => {
                                  setOpenPopupAssign(true);
                                  setId(item.id);
                                }}
                              >
                                <MdAssignmentInd fontSize="medium" />
                              </Controls.ActionButton>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </Paper>
              )}
            </Grid>
          </Grid>
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <ConfirmDialog
            confirmDialog={additionalConfirmDialog}
            setConfirmDialog={setAdditionalConfirmDialog}
          />
          <OrderAssignDialog
            confirmDialog={orderConfirmDialog}
            setConfirmDialog={setOrderConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Order Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <UpdateOrder
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setOrders={setOrders}
            getAllOrders={getAllShipmentOrders}
            edit={edit}
          />
        </Popup>
        <Popup
          title="Assign User"
          openPopup={openPopupAssign}
          setOpenPopup={setOpenPopupAssign}
        >
          <Assigntff
            type="Shipment"
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopupAssign}
            recordForEdit={recordForEdit}
            setOrders={setOrders}
            getAllOrders={getAllShipmentOrders}
            edit={edit}
            handleStatusChange={null}
            event={null}
            id={id}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default ShipmentOrder;
